import React from "react";
import {PageHero} from "../common/PageHero";

export const Youth = () => {
    return (
        <>
            <PageHero title={'Jeugd'}
                      badge={'8 tot 21 jaar'}
                      lead={'Onze jeugdtrainingen zijn er voor iedereen tussen 8 en 21 jaar.'}/>
            <div className={'ttc-section'}>
                <article className={'ttc-card featured'}>
                    <h3 className={'ttc-card-title'}>Praktische regeling</h3>
                    <ul className={'ttc-card-list'}>
                        <li>Voor beginnende spelers voorzien we paletjes, je hebt enkel sportschoenen nodig.</li>
                        <li>Aansluitingsgeld bedraagt 40€. Onze jeugdleden drinken aan verminderd tarief in onze
                            cafetaria.
                        </li>
                        <li>Competitie spelen kan, maar is nooit verplicht. De jeugdcompetitie gaat door op zaterdag van
                            9u30 tot ongeveer 12u, en wisselt tussen thuis en op verplaatsing. Vragen over de
                            jeugdtraining? Contacteer jeugdtrainer Thomas Jenné op 0496 15 01 37 of{' '}
                            <a href={'mailto:ttcbartmerksembestuur@gmail.com'}>ttcbartmerksembestuur@gmail.com</a>.
                        </li>
                    </ul>
                </article>

                <h2 className={'ttc-section-title mt-4 mb-3'}>Speelschema</h2>
                <div className={'ttc-embed'} style={{height: 420}}>
                    <iframe title={'sheet'}
                            src="https://docs.google.com/spreadsheets/d/1QB4JZIie9NNIV_txyvCPpNK2e-TLUS6DpOa5J5A-SO8/edit?gid=0#gid=0&amp;single=true&amp;widget=true&amp;headers=false"
                            style={{border: 0}}/>
                </div>
            </div>
        </>
    )
}
